import request from '@/utils/request'

// PHP 後端：w9/mobile/api_usersettings.inc.php（do=api_usersettings）
// 回傳 {code, msg, ...}，code '1' 表成功；-2 無此用戶；-3 參數錯誤；-4 無權限；-5 驗證失敗
// 非 '1' 會拋出 Error（帶 .code / .detail），呼叫方可按 code 回顯
const DO = 'api_usersettings'
const URL = '/app/index.php?i=1&c=entry&m=qicheng_messenger&do=' + DO

function assertOk(res) {
  if (res && (res.code === 1 || res.code === '1')) return res
  const err = new Error((res && res.msg) || 'Error')
  err.code = res ? String(res.code) : ''
  err.detail = res || {}
  throw err
}

export function getMerchantSettings(merchantId, role) {
  return request({
    url: URL,
    method: 'get',
    params: { action: 'get', qyid: merchantId, role: role || 'merchant' }
  }).then(assertOk)
}

export function updateMerchantSettings(merchantId, payload, role) {
  const params = { action: 'save', qyid: merchantId, role: role || 'merchant' }
  Object.keys(payload || {}).forEach(k => {
    params[k] = payload[k] == null ? '' : payload[k]
  })
  return request({
    url: URL,
    method: 'get',
    params
  }).then(assertOk)
}

export function submitMerchantSettings(merchantId, role) {
  return request({
    url: URL,
    method: 'get',
    params: { action: 'submit', qyid: merchantId, role: role || 'merchant' }
  }).then(assertOk)
}

export function resetMerchantSettings(merchantId, role) {
  return request({
    url: URL,
    method: 'get',
    params: { action: 'reset', qyid: merchantId, role: role || 'merchant' }
  }).then(assertOk)
}

export function getMerchantSettingsAudit(merchantId, limit = 12) {
  return request({
    url: URL,
    method: 'get',
    params: { action: 'audit', qyid: merchantId, limit: limit || 12 }
  }).then(assertOk)
}

export function getSettingsApiBase() {
  return DO + ' (PHP)'
}

export default { getMerchantSettings, updateMerchantSettings, submitMerchantSettings, resetMerchantSettings, getMerchantSettingsAudit }
